import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import {
    LayoutDashboard, FileText, Image as ImageIcon, Users, ClipboardList, Settings,
    BookOpen, BarChart3, Files, LogOut, Home,
} from "lucide-react";

const NAV = [
    { to: "/admin", label: "Overview", icon: LayoutDashboard, end: true },
    { to: "/admin/content", label: "Content", icon: FileText },
    { to: "/admin/programmes", label: "Programmes", icon: BookOpen },
    { to: "/admin/media", label: "Media / News", icon: FileText },
    { to: "/admin/gallery", label: "Gallery", icon: ImageIcon },
    { to: "/admin/impact", label: "Impact", icon: BarChart3 },
    { to: "/admin/documents", label: "Documents", icon: Files },
    { to: "/admin/team", label: "Team", icon: Users },
    { to: "/admin/enquiries", label: "Enquiries", icon: ClipboardList },
    { to: "/admin/settings", label: "Settings", icon: Settings },
];

export default function AdminLayout() {
    const { user, logout } = useAuth();
    const nav = useNavigate();

    return (
        <div className="min-h-screen bg-slate-50 flex" data-testid="admin-layout">
            <aside className="w-64 bg-white border-r border-slate-200 flex flex-col sticky top-0 h-screen">
                <div className="px-5 py-5 border-b border-slate-200 flex items-center gap-3">
                    <img
                        src="https://customer-assets-39nsmqrw.emergentagent.net/job_kabir-ngo-platform/artifacts/kzxgbp73_kabir%20logo%202.png"
                        alt="Kabir Foundation"
                        className="h-16 w-auto object-contain"
                    />
                    <div>
                        <div className="font-display text-base font-semibold leading-tight">Admin</div>
                        <div className="text-[10px] uppercase tracking-[0.15em] text-slate-500 mt-0.5">Dashboard</div>
                    </div>
                </div>
                <nav className="flex-1 p-3 space-y-1 overflow-y-auto">
                    {NAV.map((n) => {
                        const Icon = n.icon;
                        return (
                            <NavLink
                                key={n.to}
                                to={n.to}
                                end={n.end}
                                data-testid={`admin-nav-${n.label.toLowerCase().replace(/[\s/]+/g, '-')}`}
                                className={({ isActive }) =>
                                    `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-medium transition-colors duration-200 ${
                                        isActive ? "bg-brand-forest/10 text-brand-forest" : "text-slate-700 hover:bg-slate-100"
                                    }`
                                }
                            >
                                <Icon size={16} strokeWidth={1.75} /> {n.label}
                            </NavLink>
                        );
                    })}
                </nav>
                <div className="p-3 border-t border-slate-200 space-y-1">
                    <a href="/" target="_blank" rel="noreferrer" className="flex items-center gap-3 px-3 py-2.5 rounded-md text-sm text-slate-600 hover:bg-slate-100">
                        <Home size={16} strokeWidth={1.75} /> View public site
                    </a>
                    <div className="px-3 py-2 text-xs text-slate-500 truncate">{user?.email}</div>
                    <button
                        onClick={() => { logout(); nav("/admin/login"); }}
                        data-testid="admin-logout-btn"
                        className="w-full flex items-center gap-3 px-3 py-2.5 rounded-md text-sm text-red-600 hover:bg-red-50"
                    >
                        <LogOut size={16} strokeWidth={1.75} /> Logout
                    </button>
                </div>
            </aside>
            <main className="flex-1 min-w-0">
                <div className="p-6 lg:p-10">
                    <Outlet />
                </div>
            </main>
        </div>
    );
}
